import { HugeiconsIcon } from '@hugeicons/react';
import Link from 'next/link';
import React from 'react';
import { FaAngleDown, FaSpa } from 'react-icons/fa6';
import {
  DashboardSquare01Icon,
  SearchVisualIcon,
} from '@hugeicons/core-free-icons';
import { useFetcherCSR } from '@/lib/useFetcherCSR';

const BrowseCategories = () => {
  const { data } = useFetcherCSR('/api/v2/sidebar-data?new=true');

  return (
    <div className="header__Categories d-none d-xl-block">
      <nav className="menu">
        <ul className="menu-section">
          <li className="menu-item-has-children ms-0">
            <Link href="#" className="d-flex align-items-center">
              <span>
                <HugeiconsIcon
                  icon={DashboardSquare01Icon}
                  size={18}
                  strokeWidth={1.5}
                />
              </span>{' '}
              Browse Categories <FaAngleDown />
            </Link>
            <div className="submenu">
              <ul>
                {data?.sidebarList?.map((cat: any) => (
                  <li key={cat?.id}>
                    <Link href={`/shop?category=${cat?.slug}`}>
                      <span>
                        <HugeiconsIcon icon={SearchVisualIcon} size={16} />
                      </span>{' '}
                      {cat?.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default BrowseCategories;
